import { verticalFadeIn } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { h3 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const MotionWrapper = styled(m.div).attrs((props) => ({
    initial: 'hidden',
    animate: props['data-in-view'] ? 'visible' : 'hidden',
    transition: {
        staggerChildren: 0.1,
    },
})) `
  display: contents;
`;
const Container = styled(SectionWrapper) `
  &[data-title-placement='0'],
  &[data-title-placement='2'] {
    ${SectionWrapperStyles.Inner} {
      display: flex;
      flex-direction: column;
      gap: 32px;
    }
  }

  &[data-title-placement='1'] {
    ${SectionWrapperStyles.Inner} {
      display: flex;
      gap: ${fluid(16, 36)};
      align-items: center;

      @media ${until(Device.TabletLarge)} {
        flex-direction: column;
      }
    }
  }

  &[data-variant='1'] {
    --sectionBackground: ${brand.primary.stone};
  }
`;
const Title = styled(m.h3).attrs(() => ({ variants: verticalFadeIn() })) `
  ${h3};

  margin-bottom: 0;
  line-height: 1.25;
  text-align: center;

  span {
    background: var(--titleHighlight, currentColor);
    background-clip: text;
    color: transparent;
    display: inline;
  }
`;
const GridLayout = styled.div `
  --itemGutter: ${fluid(8, 24)};
  --visibleItems: 2;

  flex: 1;
  display: flex;
  gap: var(--itemGutter);
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  &[data-split='false'] {
    @media ${from(Device.Tablet)} {
      --visibleItems: 3;
    }

    @media ${from(Device.TabletLarge)} {
      --visibleItems: 4;
    }

    @media ${from(Device.DesktopSmall)} {
      --visibleItems: 6;
    }

    @media ${from(Device.DesktopLarge)} {
      --visibleItems: 8;
    }
  }

  &[data-split='true'] {
    @media ${until(Device.TabletLarge)} {
      width: 100%;
    }

    @media ${from(Device.DesktopLarge)} {
      --itemGutter: 16px;
      --visibleItems: 4;
    }
  }
`;
const Award = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(),
})) `
  flex: 0 0
    calc(
      100% / var(--visibleItems) -
        (var(--itemGutter, 0px) * ((var(--visibleItems) - 1) / var(--visibleItems)))
    );
  height: ${fluid(91, 126)};
  border-radius: 8px;
  position: relative;
  display: flex;
  justify-content: center;

  [data-title-placement='1'] & {
    max-height: 108px;
  }

  iframe {
    height: 100%;
    width: 100%;
    position: absolute;
    inset: 0;
  }

  img {
    display: block;
    top: 50%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  @media ${from(Device.TabletLarge)} {
    [data-variant='1'] & {
      padding: 14px 22px;
      background-color: ${brand.primary.white};

      img {
        max-height: calc(100% - 28px);
        max-width: calc(100% - 44px);
      }
    }
  }
`;
export const AwardsBannerStyles = {
    Container,
    Title,
    GridLayout,
    Award,
    MotionWrapper,
};
